import { notificationChannelService } from '@/services/api/notificationChannel.service';
import { notificationChannelModel } from '@/models/api/notificationChannel.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const NOTIFICATION_CHANNEL_MODULE = 'api/notificationChannel';
export const GET_ALL_NOTIFICATION_CHANNEL = 'getAllNotificationChannel';
export const UPDATE_NOTIFICATION_CHANNEL_STATUS = 'updateNotificationChannelStatus';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 1,
            pageSize: 15,
            lastPage: 1,
            tableRowsCounts: 0,
            total: 0
        }
    },
    status: {
        list: true,
        save: true
    },
};

export const actions = {
    async [GET_ALL_NOTIFICATION_CHANNEL]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await notificationChannelService.getAll(filter);
            commit('listSuccess', result);
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [UPDATE_NOTIFICATION_CHANNEL_STATUS]({ commit, dispatch }, { uuid, isActive, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationChannelService.updateStatus(uuid, isActive);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('label.status')]) });
            await dispatch(GET_ALL_NOTIFICATION_CHANNEL, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type = 'list') {
        state.status[type] = false;
    },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(notificationChannelModel);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
        state.status.list = true;
    },
    success(state) {
        state.status = {
            list: true,
            save: true
        };
    },
    failure(state) {
        state.status = {
            list: true,
            save: true
        };
    },
};
